import { render } from "./Holders.vue?vue&type=template&id=f2424228"
import script from "./Holders.vue?vue&type=script&lang=js"
export * from "./Holders.vue?vue&type=script&lang=js"
script.render = render

export default script